import React from 'react'

interface MotivationIconProps {
  size?: number
  className?: string
}

export const MotivationIcon: React.FC<MotivationIconProps> = ({ size = 17, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M2.66 2.66C2.64 2.16 2.82 1.66 3.17 1.29C3.51 0.91 3.99 0.69 4.5 0.66C7.21 0.66 8.16 4.66 8.16 4.66H4.5C3.99 4.64 3.51 4.42 3.17 4.04C2.82 3.67 2.64 3.17 2.66 2.66Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.66 2.66C13.69 2.16 13.5 1.66 13.16 1.29C12.82 0.91 12.34 0.69 11.83 0.66C9.12 0.66 8.16 4.66 8.16 4.66H11.83C12.34 4.64 12.82 4.42 13.16 4.04C13.5 3.67 13.69 3.17 13.66 2.66Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.66 9.66V14.16C13.66 14.56 13.51 14.94 13.22 15.22C12.94 15.51 12.56 15.66 12.16 15.66H4.16C3.77 15.66 3.38 15.51 3.1 15.22C2.82 14.94 2.66 14.56 2.66 14.16V9.66" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.66 4.66H0.66V7.66H15.66V4.66Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
